import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

/**
 * Docs: https://github.com/ember-cli/ember-cli-deprecation-workflow
 */
setupDeprecationWorkflow({
  /**
    false by default, but if a developer / team wants to be more aggressive about being proactive with
    handling their deprecations, this should be set to "true"
  */
  throwOnUnhandled: false,
  workflow: [
    /* Ember */
    { handler: 'throw', matchId: 'template-action' },
    { handler: 'silence', matchId: 'importing-inject-from-ember-service' },

    {
      handler: 'silence', //ember-data
      matchId: 'deprecate-import-libraries-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version ffs
      matchId: 'deprecate-import--set-classic-decorator-from-ember',
    },
    {
      handler: 'silence', // just throws before anything loads
      matchId: 'deprecate-import-test-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version
      matchId: 'deprecate-import--is-destroying-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version
      matchId: 'deprecate-import--is-destroyed-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version
      matchId: 'deprecate-import-destroy-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version
      matchId: 'deprecate-import--register-destructor-from-ember',
    },
    {
      handler: 'silence', // ember-cli-new-version
      matchId: 'deprecate-import-testing-from-ember',
    },
    {
      handler: 'silence', // ember-data
      matchId: 'deprecate-import-meta-from-ember',
    },
    {
      handler: 'throw',
      matchId: 'deprecate-import-env-from-ember',
    },
    /* Ember Data */
    {
      handler: 'throw',
      matchId: 'ember-data:deprecate-non-strict-relationships',
    },
    { handler: 'throw', matchId: 'ember-data:deprecate-early-static' },
    { handler: 'throw', matchId: 'ember-data:deprecate-array-like' },
    { handler: 'silence', matchId: 'ember-data:deprecate-promise-proxies' },
    {
      handler: 'silence',
      matchId: 'ember-data:deprecate-promise-many-array-behaviors',
    },
    { handler: 'throw', matchId: 'ember-data:no-a-with-array-like' },
  ],
});
